import { render, staticRenderFns } from "./ProofUpload.vue?vue&type=template&id=11c8073f&scoped=true&lang=pug&"
import script from "./ProofUpload.vue?vue&type=script&lang=js&"
export * from "./ProofUpload.vue?vue&type=script&lang=js&"
import style0 from "./ProofUpload.vue?vue&type=style&index=0&id=11c8073f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c8073f",
  null
  
)

export default component.exports